export const blankHandler = function blankHandler() {
    return undefined;
};
